<!--=================================
=            LAYOUT MINI            =
==================================-->

<template>
  <div>


    <!--sidebar right -->
    <v-navigation-drawer v-model="drawerRight" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" temporary fixed
                         class="  d-print-none mx-auto" :right="!$vuetify.rtl">
      <base-settings></base-settings>
    </v-navigation-drawer>

    <!-- sidebar mini-->
    <v-navigation-drawer v-model="drawer" app style="width:100px;height:1800px!important;" class="d-flex float-left"
                         :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" mini-variant>
      <perfect-scrollbar>
        <drawer-mini></drawer-mini>
      </perfect-scrollbar>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="gohome()" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" class="white--text" block>
            <v-icon>logout</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <!-- main-->
    <v-main  :class="$vuetify.theme.dark ? 'dark' : 'light'">
      <!--container -->
      <v-container class="transparent mb-8"  aspect-ratio="1.7"
          contain>
        <!-- If using vue-router -->
         <sequential-entrance>  <router-view></router-view>  </sequential-entrance>
        <!--btn right -->
        <v-btn @click.stop="drawerRight=!drawerRight" class=" product-upgrade-to-pro error">
          <v-icon size="30" dark> settings
          </v-icon>
        </v-btn>
      </v-container>
    </v-main>
    <!--footer -->
    <base-footer></base-footer>
  </div>
</template>

<script>
  import {
    PerfectScrollbar
  } from "vue2-perfect-scrollbar";
  import {
    mapMutations,
    mapState
  } from 'vuex'
  import BaseFooter from '../components/Base/BaseFooter'
  import DrawerMini from '../components/Drawer/DrawerMini'
  import BaseSettings from '../components/Base/BaseSettings'
  export default {
    components: {
      PerfectScrollbar,
      DrawerMini,
      BaseSettings,
      BaseFooter
    },
    data() {
      return {
        drawerRight: false,
        sidebarMenu: true,
        drawer: true,
        searchActive: false,
        align: 'center',
      }
    },
    methods: {
      gohome() {
        return this.$router.push("/");
      },
    
    },


  }
</script>
<style>
  .light {
    background-image: url('../assets/images/bg/5.jpg'); 
    background-size: 100%!important;
  }

  .dark {
    background-image: url('../assets/images/bg/dark.jpg');

     background-size: 100%!important;
  }


  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5) !important;
    background: rgba(255, 255, 255, 0.2) !important;
    -webkit-backdrop-filter: blur(20px) !important;
    backdrop-filter: blur(20px) !important;
    transform: perspective(500px) !important;
    transform-style: preserve-3d !important;
  }

  .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5) !important;
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5) !important;
    background: rgba(0, 0, 0, 0.2) !important;
    -webkit-backdrop-filter: blur(20px) !important;
    backdrop-filter: blur(20px) !important;
    transform: perspective(500px) !important;
    transform-style: preserve-3d !important;
  }

  .theme-dark {
    background: #004c4c !important;
  }

  .theme-light {
    background: #f3f6fd !important;
  }



  .ps {
    height: 100%
  }

  .v-navigation-drawer__content {
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
  }
</style>


<style lang="scss" scoped>
  .product-upgrade-to-pro {
    z-index: 4;
    top: 50%;
    right: 1px;
    position: fixed;

    .v-application &.v-btn.v-btn--is-elevated {
      box-shadow: 0 1px 20px 1px #ff4c51 !important;

      &:hover {
        box-shadow: none !important;
      }
    }
  }
</style>

<!--====  End of LAYOUT MINI  ====-->